const PriorityConstants = {
  Emergency: '01_Emergency',
  Routine: '03_Routine',
  Urgent: '02_Urgent',
  COM: '08_COM',
  'Internal Work Order': '09_Internal Work Order',
};

export default PriorityConstants;
